import { useQuery } from "@tanstack/react-query";
import { BrandSearchResult, BrandsService } from "@/services/brands.service";
import { adsHttpClient } from "@/utils/ads.http";

const brandsService = new BrandsService(adsHttpClient);

export type Brand = BrandSearchResult;

async function fetchBrandsCatalog(query = ""): Promise<Brand[]> {
  return brandsService.searchByName(query);
}

type UseBrandsCatalogOptions = {
  enabled?: boolean;
};

export function useBrandsCatalog(
  query = "",
  options: UseBrandsCatalogOptions = {},
) {
  const normalizedQuery = query.trim();

  return useQuery({
    queryKey: ["brands-catalog", normalizedQuery],
    queryFn: () => fetchBrandsCatalog(normalizedQuery),
    enabled: options.enabled ?? true,
  });
}
